<template>
<div class="user-select-none" id="app" >
  <div v-if="$Global.langObj != ''" class="appnoshow font">
    <div class="d-flex justify-content-center">
      <div>
        <div class="d-flex justify-content-start">{{$Global.langObj[$Global.lang].your_resolution_is_not_enough}}</div>
        <div class="d-flex justify-content-start" style="color:red">{{$Global.langObj[$Global.lang].please_reduce_the_browser_window_resolution}}</div>
        <div class="d-flex justify-content-start">{{$Global.langObj[$Global.lang].your_current_resolution_is}}{{$Global.fullWidth}} X {{$Global.fullHeight}}.</div>
        <div class="d-flex justify-content-start">{{$Global.langObj[$Global.lang].the_system_recommends_a_resolution_of_1024_X_768_or_higher}}</div>
      </div>
    </div>
  </div>
  <div class="appshow">
    <!-- 車機Command -->
    <div v-if="$Vehicle.CommandShow && $Vehicle.UnitListDetailShow && !$Vehicle.MultiViewChckbox" class="Command font p-2">
      <div @click="$Vehicle.Command()" class="bluecancel" style="top:2.5px">
        <i class="fa fa-times"></i>
      </div>
      <font style="position:absolute;left:10px;top:5px">{{$Vehicle.ClickUnitInfo.protoCode}}</font>
      <div class="w-100 d-flex justify-content-center CommandTitleBorder py-1">{{$Vehicle.ClickUnitInfo.identifier}}</div>
      <div class="w-100 d-flex px-2 py-2">
        <input class="Command-input font" style="margin-right:5px" v-model="$Vehicle.CommandText" :placeholder="$Global.langObj[$Global.lang].AT_Command">
        <input @click="$Vehicle.SendCommand()" type="button" :value="$Global.langObj[$Global.lang].Send" class="CommandSend">
      </div>
      <div class="w-100 d-flex px-2">
        <select @change="changeCmmand()" class="global-select font" style="height:35px" v-model="$Vehicle.syntax">
          <option disabled value="0">{{$Global.langObj[$Global.lang].AT_Command}}</option>
          <option v-for="item in $Vehicle.CommandList" :key="item.ProtoID" :value="item.syntax">{{item.name}}</option>
        </select>
      </div>
      <div v-if="!$Vehicle.CommandLoading" class="w-100 px-2 my-2 text-start user-select-text" style="word-break: break-all;">
        {{$Vehicle.CommandResponse}}
      </div>
      <div v-if="$Vehicle.CommandLoading"  class="w-100">
        <i class="my-3 fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true"></i>
      </div>
    </div>
    <!-- 車機Command -->
    <!-- 車機Command密碼輸入 -->
    <div v-if="$Vehicle.LockCommandPasswordShow" class="LockCommandPassword">
      <div @click="$Vehicle.CancelLockCommand()" class="bluecancel" style="top:2.5px">
        <i class="fa fa-times"></i>
      </div>
      <div class="w-100 d-flex" style="margin-top:35px">
        <input type="password" class="Command-input font mx-2" v-model="$Vehicle.LockCommandPasswordStr" :placeholder="$Global.langObj[$Global.lang].password" @keyup.enter="$Vehicle.LockCommandOKClick()">
        <div @click="$Vehicle.LockCommandOKClick()" style="cursor:pointer" class="mx-1 d-flex justify-content-center align-items-center CommandSend">OK</div>
      </div>
    </div>
    <!-- 車機Command密碼輸入 -->
    <div v-if="show" :class="$Global.Noneactive">
      <!-- <img src="./assets/logo.png"> -->
      <!-- <div v-if="this.$Global.showskinbtn" v-on:click="SelectSkinBtn()" style="position: absolute; z-index: 2;bottom:0px; right:0px; width: 40px; height: 40px; cursor: pointer">
        <img id="skinbtnimg" style="position:absolute; top:0px; left:0px; z-index: 2;" :src="SelectSkinBtnSrc"/>
      </div> -->
      <!-- <div id="selectskin" style="position: absolute; display:none; z-index: 2; bottom: 20px; right:0px; width: 40px; height: 80px;">
          <div v-on:click="SelectSkin('black')" id="blackskin" style="cursor: pointer">
              <img style="position: relative; z-index: 2;" src="@/assets/svg/style_colorplate.svg" />
          </div>
          <div v-on:click="SelectSkin('white')" id="whiteskin" style="cursor: pointer">
              <img style="position:relative;z-index:2;top:-10px" src="@/assets/svg/style_colorplate_01.svg" />
          </div>
      </div> -->
      <router-view v-if="isRouterAlive"></router-view>
      <!-- <router-view v-if="isRouterAlive"/> -->
    </div>
    <div v-if="load" class="Loaderposition">
      <div class="Loader">
      <!--  We have to declare some variables.  -->
        <span style="--i:1"></span>
        <span style="--i:2"></span>
        <span style="--i:3"></span>
        <span style="--i:4"></span>
        <span style="--i:5"></span>
        <span style="--i:6"></span>
        <span style="--i:7"></span>
        <span style="--i:8"></span>
        <span style="--i:9"></span>
        <span style="--i:10"></span>
        <span style="--i:11"></span>
        <span style="--i:12"></span>
        <span style="--i:13"></span>
        <span style="--i:14"></span>
        <span style="--i:15"></span>
        <span style="--i:16"></span>
        <span style="--i:17"></span>
        <span style="--i:18"></span>
        <span style="--i:19"></span>
        <span style="--i:20"></span>
      </div>
    </div>
    <iframe style="position:absolute;top:0;left:0" name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'App',
  provide() {//provide for all child vue use
    return {
      reload: this.reload //Same F5 reload
    };
  },
  created(){
    //Unit Test
    // this.$APIjs.UnitTest()
    //載入語言包
    this.$Global.langObj = language
    this.$Global.EventLanguageObj = EventLanguage
    //getV3data
    // if(this.$route.fullPath.indexOf('?') != -1){
    //   this.GetV3Data()
    // }
    //getV3data
    this.$Global.SetTheme(localStorage.getItem('theme'))
    // this.SelectSkin(localStorage.getItem('theme'))
    // this.$Global.load = true
    //預設語言
    if((localStorage.getItem('Lang') == 'null' || localStorage.getItem('Lang') == undefined) || (localStorage.getItem('Lang') != 'zh-tw' && localStorage.getItem('Lang') != 'en-us' && localStorage.getItem('Lang') != 'ja-JP' && localStorage.getItem('Lang') != 'es-MX')){
      localStorage.setItem('Lang','en-us')
      this.$Global.lang = 'en-us'
      // this.GetLangAll('en-us')
    }else{
      this.$Global.lang = localStorage.getItem('Lang')
      // this.GetLangAll(localStorage.getItem('Lang')) 
    }
    this.$Global.ChangeManageMenuLang()
    switch (localStorage.getItem('Unit')) {
      case 'km':
        localStorage.setItem('Unit','km')
        this.$Global.Unit_local = 'km'
        this.$Global.Unit = this.$Global.langObj[this.$Global.lang].kM
        break;
      case 'mi':
        localStorage.setItem('Unit','mi')
        this.$Global.Unit_local = 'mi'
        this.$Global.Unit = this.$Global.langObj[this.$Global.lang].mile
        break;
      default:
        localStorage.setItem('Unit','km')
        this.$Global.Unit_local = 'km'
        this.$Global.Unit = this.$Global.langObj[this.$Global.lang].kM
        break;
    }
    this.gettimeformat(localStorage.getItem('timeformat'))
    //監聽高寬度
    const vm = this;
    vm.$Global.fullWidth = window.innerWidth;
    vm.$Global.fullHeight = window.innerHeight;
    window.onresize = () => {
      vm.$Global.fullWidth = window.innerWidth;
      vm.$Global.fullHeight = window.innerHeight;
    };
  },
  mounted(){
    //監聽斷線離線
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    // console.log(this.$Global)
    setTimeout(() => {
      // this.$Global.load = false
      this.show = true
    }, 0);

  }, 
  beforeDestroy() {
  },
  data:function () {
  return {
      SelectSkinBtnSrc:require('@/assets/svg/style_colorplate.svg'),
      show:false,
      this_:this.$APIjs,
      this_Global:this.$Global,
      load:false,
      V3data:'',
      isRouterAlive: true,
      onLine: navigator.onLine,
    }
  },
  watch:{
    'this_Global.load':function(){
      if(this.$Global.load){
        this.load = true
      }else{
        this.load = false
      }
    },
    'this_.invalid_token_to_login':function(){
      this.Goto(this.$APIjs.invalid_token_to_login)
    },
    // 'this_.ManageLangObj':function(){
    //   this.$Global.ChangeManageMenuLang()
    //   this.show = true
    // },
  },
  methods:{
    changeCmmand(){
      if(this.$Vehicle.syntax==null){
        return
      }
      this.$Vehicle.CommandText = this.$Vehicle.syntax
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === 'online';
      if(!this.onLine){
        this.$Global.GlobalOffline = true
      }else{
        this.$Global.GlobalOffline = false
      }
      // this.beforeDestroy()
    },
    beforeDestroy(){//單次偵測需要用到
      window.removeEventListener('online',  this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOnlineStatus);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    gettimeformat(timeformat){
      switch (timeformat) {
        case 'YYYY/MM/DD':
          localStorage.setItem('timeformat','YYYY/MM/DD')
          break;
        case 'MM/DD/YYYY':
          localStorage.setItem('timeformat','MM/DD/YYYY')
          break;
        case 'DD/MM/YYYY':
          localStorage.setItem('timeformat','DD/MM/YYYY')
          break;      
        default:
          localStorage.setItem('timeformat','YYYY/MM/DD')
          break;
      }
    },
    Goto(page){
      this.$SignalRjs.ConnectionStop()
      setTimeout(() => {
        alert(this.$Global.langObj[this.$Global.lang].The_connection_has_expired)
        this.$router.push({ name: page }).catch(()=>{})
      }, 5000);
    },
    // GetLangAll(Lang){
      // this.$APIjs.GetLang(Lang).then(result=>{
        // var ManageLang = ''
        // this.$Global.lang = Lang
        // switch (Lang) {
        //   case 'zh-tw':
        //     ManageLang = 'zh-TW'
        //     break;
        //   case 'en-us':
        //     ManageLang = 'en-US'
        //     break;       
        //   default:
        //     ManageLang = 'en-US'
        //     break;
        // }
        // this.$APIjs.GetManageLang(ManageLang).then(result=>{
        //   this.$Global.load = false
        // })
      // })
    // },
    // GetV3Data(){
      //取隱藏值
      // var this_ = this
      // function receiveMessage(event){
      //   // console.log(event)
      //   var data = event.data
      //   var eventjson = JSON.parse(data)
      //   this_.SelectSkin(eventjson.bgclr)
      //   this_.$cookie.set('Lang',eventjson.Culture)
      //   this_.$cookie.set('username',eventjson.username)
      //  this_.$cookie.set('token',eventjson.token)
      //  this_.$APIjs.accounttoken = ''
      //  this_.$APIjs.accounttoken = eventjson.token
      //   this_.$APIjs.username = eventjson.username
      //   this_.$APIjs.GetLang(this_.$cookie.get('Lang'))
      // }
      // window.addEventListener("message", receiveMessage, false);
      //取url值
      // var this_ = this
      // this_.V3data=atob(decodeURIComponent(this_.$route.fullPath.split('?')[1]))
      // this_.$Global.SetTheme(this_.V3data.split('bgclr=')[1].split('&')[0])
      // // this_.SelectSkin(this_.V3data.split('bgclr=')[1].split('&')[0])
      // localStorage.setItem('Lang',this_.V3data.split('lang=')[1].split('&')[0])
      // this.$Global.load = true
      // // this.GetLangAll(localStorage.getItem('Lang'))
      // localStorage.setItem('username',this_.V3data.split('username=')[1])
      // this_.$APIjs.username = this_.V3data.split('username=')[1]
      // var token = 'Bearer '+ this_.V3data.split('token=')[1].split('&')[0].slice(1,-1)
      // localStorage.setItem('token',token)
      // this_.$APIjs.accounttoken = ''
      // setTimeout(() => {
      //   this_.$APIjs.accounttoken = token
      // }, 1);
    // },
    // SelectSkinBtn(){
    //   if(this.$('#selectskin').css('display')=='none'){
    //     this.$('#selectskin').css('display','block')
    //   }else{
    //     this.$('#selectskin').css('display','none')
    //   }
    // },
    // SelectSkin(skin){
    //   switch (skin) {
    //     case 'black':
    //       this.$("#skincss").attr("href", '/static/black_theme.css')
    //       this.$('#selectskin').css('display','none')
    //       localStorage.setItem('theme','black')
    //       this.SelectSkinBtnSrc = require('@/assets/svg/style_colorplate.svg')
    //       break;
    //     case 'white':
    //       this.$("#skincss").attr("href", '/static/white_theme.css')
    //       this.$('#selectskin').css('display','none')
    //       localStorage.setItem('theme','white')
    //       this.SelectSkinBtnSrc = require('@/assets/svg/style_colorplate_01.svg')
    //       break;
    //     default:
    //       this.$("#skincss").attr("href", '/static/black_theme.css')
    //       this.$('#selectskin').css('display','none')
    //       localStorage.setItem('theme','black')
    //       this.SelectSkinBtnSrc = require('@/assets/svg/style_colorplate.svg')
    //       break;
    //   }
    // }
  }
}
</script>
<style lang="sass">
</style>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  letter-spacing: 1px;
  /* margin-top: 60px; */
}
.Loaderposition{
  position: fixed;
  z-index: 100;
  top: calc(50% + -50px);
  left: calc(50% + -50px);
}
/*Loading*/
.Loader{
  /* background: red; */
  height: 100px;
  width: 100px;
  position: relative;
/*     border-radius: 50%; */
}

.Loader span{
  position: absolute;
  /* background: black; */
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;

/*  Roatating every span to 18deg with the help of variable  */
  transform: rotate(calc(18deg * var(--i)));

/*   For changing color  */
  animation: animate 1s linear infinite;
}

@keyframes animate {
  0%{
      filter: hue-rotate(0deg);
  }

  100%{
      filter: hue-rotate(360deg);
  }
  
}

.Loader span::before{
  content: "";
  position: absolute;
  opacity: 0.5;
  box-shadow: 
  0 0 10px transparent,
  0 0 20px transparent,
  0 0 40px transparent,
  0 0 80px transparent,
  0 0 100px transparent;
  height: 12.5px;
  width: 12.5px;
  border-radius: 50%;

/*  for disappearing and then appearing  */
  animation: loading 1s linear infinite; 

/*  To making appearing and disappearing of every element different  */
  animation-delay: calc(0.05s * var(--i));
}

@keyframes loading {
  0%{
      transform: scale(1);
  }

  80%, 100%{
      transform: scale(0.2);
  }
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue